import { Island, MiniGrid, MiniGridRow, Stub, VStack } from '@direct-frontend/components';
import { TreeStub } from '#shared/components/Tree';
import styles from './CharacteristicsActiveStub.module.css';

export function CharacteristicsActiveStub() {
    return (
        <Island>
            <VStack gap="28">
                <VStack gap="6">
                    <Stub height={20} width={280} />
                    <Stub borderRadius="14" height={36} />
                </VStack>
                <Stub borderRadius="14" height={36} />
                <MiniGrid cellSize="m">
                    <MiniGridRow id="characteristic-active-grid-stub">
                        <div className={styles.treeWrapper}>
                            <TreeStub width={606} isEditor isFlat size="m" />
                        </div>
                    </MiniGridRow>
                </MiniGrid>
            </VStack>
        </Island>
    );
}
